<div class="breadcrumb-floating" *ngIf="breadcrumbs.length > 1">
  <div
    class="breadcrumb-container bg-gray-50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 mx-4 my-2 px-4 py-2">
    <ol class="flex items-center space-x-1 text-xs">
      <li *ngFor="let breadcrumb of breadcrumbs; let last = last" class="flex items-center">


        <a *ngIf="breadcrumb.label === 'Home' && !last" [routerLink]="breadcrumb.url"
          class="flex items-center gap-1 px-2 py-1 rounded transition-all duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 text-white hover:text-gray-900">
          <lucide-icon name="home" class="w-4 h-4"></lucide-icon>
          <span class="font-medium">{{ breadcrumb.label }}</span>
        </a>


        <a *ngIf="breadcrumb.label !== 'Home' && !last" [routerLink]="breadcrumb.url"
          class="flex items-center px-2 py-1 rounded transition-all duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 text-white hover:text-gray-900">
          <span class="font-medium">{{ breadcrumb.label }}</span>
        </a>


        <span *ngIf="last" class="flex items-center px-2 py-1 rounded bg-red-600 shadow-md">
          <span class="font-semibold text-white">{{ breadcrumb.label }}</span>
        </span>


        <lucide-icon *ngIf="!last" name="chevron-right"
          class="w-3 h-3 mx-1 text-gray-400 dark:text-gray-500"></lucide-icon>
      </li>
    </ol>
  </div>
</div>